import React, { Fragment } from 'react'

import { Typography } from '@mui/material'

import { useStyles } from './styles'

import { usePutAway } from '../../Context/usePutAway'

interface ValidationPutAwayProps {}

export const ValidationPutAway: React.FC<ValidationPutAwayProps> = () => {
  const classes = useStyles()
  const { state } = usePutAway()
  const { error } = state

  if (error.error.length > 0) {
    return (
      <Typography
        className={`${classes.putAwayValidationBase}  ${
          error.status === 'error'
            ? classes.putAwayValidationError
            : classes.putAwayValidationSuccess
        }`}
      >
        {error.error}
      </Typography>
    )
  }
  return <Fragment />
}
